let config = {
  emailjs: {
    serviceID: "gmail",
    templateID: "template_zHretJ0d",
    userID: "user_8g0rh3d6Qj1QZBEU8USls"
  }
};

export default config;
